import React, { useState } from "react";
import "./DownItem.css";
import qrCodeTriangle from "../../../assets/images/qr-code-triangle.png"; // 引入图片

const DownloadCard = ({ icon, title, onClick, qrCode }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="download-card"
      title={title}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* QR Code Triangle Image */}
      <img
        className={`qrCodeImg ${isHovered ? "hidden" : ""}`} // Added class "hidden" to fade out
        src={qrCodeTriangle}
        alt="QR Code Triangle"
      />

      {/* QR Code Container */}
      {qrCode && (
        <div
          className={`qr-code ${isHovered ? "expanded" : ""} ${isHovered ? "show" : ""
            }`}
        >
          <img src={qrCode} alt="QR Code" />
        </div>
      )}

      <img className="picon" src={icon} alt={title} />

      {/* Title */}
      <p className="download-subtitle global-text">{title}</p>
    </div>
  );
};

export default DownloadCard;
